<template>
  <div class="search_container">
    <div class="search_bar">
      <b-form-input
        size="sm"
        :value="keyword"
        v-on:keyup.enter="doSearch"
        v-on:keyup.esc="clearSearch"
        @input="changeSearch"
        placeholder="Поиск"
      />

      <b-button size="sm" variant="search" @click="doSearch">Искать</b-button>
      <b-button size="sm" variant="light" @click="clearSearch">Все</b-button>
    </div>

    <div v-if="global" class="search_global">
      <b-form-checkbox size="sm" v-model="searchGlobal" name="search_global">
        Искать по всему каталогу
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SearchBar",
  data: () => ({
    keyword: null,
    searchGlobal: true
  }),
  computed: {
    ...mapGetters({
      searchMode: "search/searchMode",
      selected_group: "groups/get_selected"
    })
  },
  props: ["global"],
  methods: {
    changeSearch(keyword) {
      this.keyword = keyword;
      this.$store.commit("search/setKeyword", keyword);
    },
    doSearch() {
      this.$store.commit("search/setSearchMode", true);
      this.$router.push({
        name: "catalog",
        query: {
          q: this.keyword,
          global: this.searchGlobal
          //group_id: this.selected_group.id
        }
      });
    },
    clearSearch: function() {
      this.$store.commit("search/setKeyword", null);
      this.$store.commit("search/setSearchMode", false);
      this.$router.push({
        name: "catalog"
      });
    }
  },
  watch: {
    searchGlobal(newVal) {
      this.$store.commit("search/setSearchGlobal", newVal);
    }
  }
};
</script>

<style lang="sass">
.search_bar
  display: flex
  justify-content: flex-end

  input, button:not(:last-child)
    margin-right: 10px

.btn.btn-search
  color: #fff
  background-color: darken(#3eb141, 8%)
  border-color: darken(#3eb141, 8%)

.search_global
  margin-top: 4px

.search_container
  flex-direction: column
</style>
